<template>
	<nut-navbar
		class="navbar"
		title="版本与升级"
		leftShow
		@on-click-back="goBack"
	></nut-navbar>
	<div class="container">
		<div class="info">
			<div class="info-header">
				<span class="title">当前APP版本</span>
				<span class="version">{{ pageData.version }}</span>
			</div>
			<div class="desc">{{ pageData.date }}</div>
		</div>
		<div class="info">
			<div class="info-header">
				<span class="title">最新APP版本</span>
				<span class="version">{{ pageData.new_version }}</span>
			</div>
			<div class="desc" v-if="Array.isArray(pageData.changelog)">
				<p v-for="log in pageData.changelog" :key="log">
					{{ log }}
				</p>
			</div>
		</div>
		<div class="btn-container">
			<nut-button
				:disabled="disabled"
				@click="handleUpdate"
				class="btn"
				block
				type="primary"
			>
				立即升级
			</nut-button>
		</div>
		<help-text-tip @click="handleOpenDialog(UPGRADE_APP_HELP)">
		</help-text-tip>
	</div>

	<nut-dialog
		teleport="body"
		title="提示"
		v-model:visible="visible"
		okText="立即升级"
		@ok="handleConfirmUpdate"
	>
		<ul style="text-align: left">
			<li>1.APP将进入升级过程！</li>
			<li>
				2.请使用鼠标/键盘/触摸屏/遥控器等，在屏幕上根据提示选择接受“安装”！
			</li>
			<li>
				3.请在空闲时段进行本操作。升级过程中禁止对本设备进行其他操控！
			</li>
		</ul>
	</nut-dialog>
</template>

<script>
import { ref, onMounted } from 'vue';
import { HelpTextTip } from '@/components';
import useDialog from '@/hooks/useDialog';
import { UPGRADE_APP_HELP } from '@/constants/tiptype';
import useNavigate from '@/hooks/useNavigate';
import { deviceApi } from '@/apis';
import { Toast } from '@nutui/nutui';

export default {
	name: 'AppUpdate',
	components: {
		HelpTextTip,
	},
	setup() {
		const pageData = ref({});
		const visible = ref(false);
		const disabled = ref(false);
		const { goBack } = useNavigate();
		const { handleOpenDialog } = useDialog();
		const handleUpdate = () => {
			visible.value = true;
		};

		const handleConfirmUpdate = async () => {
			console.log('updating');
			await deviceApi.update_submit();
			Toast.text('命令已发送');
			disabled.value = true;
		};

		const getData = async () => {
			const data = await deviceApi.update_load_data();
			pageData.value = data;
			disabled.value = !data.ready;
		};

		onMounted(() => {
			getData();
		});
		return {
			disabled,
			visible,
			pageData,
			UPGRADE_APP_HELP,
			goBack,
			handleOpenDialog,
			handleUpdate,
			handleConfirmUpdate,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	overflow: hidden;
	background: $bg_color;
}

.info {
	margin-bottom: 10px;
	background: #fff;
	padding: 15px;

	color: #999;
	&-header {
		@include flex-center;
		margin-bottom: 12px;
	}

	.title {
		font-size: 14px;
		font-weight: 500;
		color: #333;
	}

	.version {
		font-size: 12px;
	}

	.desc {
		font-size: 12px;

		p {
			height: 24px;
		}
	}
}
</style>
